<template>
    <div>
        <div id="ticket_responsive" style="display:none;">
            <div id="ticket_inner" style="background-color: #2B6CA0; height: 46px; padding: 3% 7%; ">
                <button class="float-left"  @click="backButton">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.00135 9.99865C8.00109 9.8652 8.04757 9.73588 8.13271 9.63312L10.9884 6.20632C11.0853 6.08969 11.2246 6.01634 11.3757 6.00242C11.5267 5.98849 11.677 6.03513 11.7937 6.13208C11.9103 6.22902 11.9837 6.36833 11.9976 6.51935C12.0115 6.67037 11.9649 6.82074 11.8679 6.93737L9.30925 9.99865L11.7765 13.0599C11.824 13.1183 11.8594 13.1856 11.8808 13.2577C11.9022 13.3299 11.9091 13.4055 11.9011 13.4804C11.8932 13.5552 11.8705 13.6277 11.8344 13.6938C11.7983 13.7598 11.7495 13.8181 11.6909 13.8652C11.6321 13.9175 11.5633 13.9571 11.4885 13.9816C11.4138 14.006 11.3348 14.0148 11.2565 14.0073C11.1782 13.9997 11.1023 13.9762 11.0336 13.938C10.9648 13.8998 10.9047 13.8478 10.857 13.7853L8.09844 10.3585C8.02676 10.2528 7.99257 10.1261 8.00135 9.99865Z" fill="white"/>
                    <rect x="19.5" y="0.5" width="19" height="19" rx="3.5" transform="rotate(90 19.5 0.5)" stroke="white"/>
                </svg>
                </button>

                <div class="float-left"  id="support_heading" >
                    <p  style="color:white;  font-family:Mulish,sans-serif;font-size: 16px !important;">Support</p>
                </div>
                <a v-if="$route.fullPath == '/support'"  @click="filterCheck" class="float-right" id="filter_responsive">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.8422 5H5.57895C5.4254 5 5.27815 5.061 5.16957 5.16957C5.061 5.27815 5 5.4254 5 5.57895V7.07844C5 7.38123 5.12332 7.67881 5.33753 7.89302L8.47371 11.0292V15.4211C8.47382 15.5198 8.49911 15.6167 8.54718 15.7029C8.59525 15.789 8.6645 15.8615 8.74839 15.9133C8.83228 15.9652 8.92802 15.9948 9.02655 15.9994C9.12509 16.0039 9.22315 15.9832 9.31145 15.9393L11.6273 14.7814C11.8235 14.683 11.9474 14.4827 11.9474 14.2632V11.0292L15.0836 7.89302C15.2978 7.67881 15.4211 7.38123 15.4211 7.07844V5.57895C15.4211 5.4254 15.3601 5.27815 15.2516 5.16957C15.143 5.061 14.9957 5 14.8422 5ZM10.9592 10.3802C10.9053 10.4339 10.8626 10.4977 10.8335 10.5679C10.8043 10.6382 10.7894 10.7135 10.7895 10.7895V13.9054L9.63162 14.4844V10.7895C9.63173 10.7135 9.61679 10.6382 9.58768 10.5679C9.55857 10.4977 9.51585 10.4339 9.46198 10.3802L6.1579 7.07844V6.1579H14.2638L14.265 7.07438L10.9592 10.3802Z" fill="white"/>
                        <rect x="19.5" y="0.5" width="19" height="19" rx="3.5" transform="rotate(90 19.5 0.5)" stroke="white"/>
                    </svg>
                </a>
                <router-link v-if="$route.fullPath == '/support'" to="/support/generate" class="float-right " id="add_new_responsive">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4585 4.5H9.54185C9.46037 4.5 9.41963 4.54074 9.41963 4.62222V9.41944H4.86685C4.78537 9.41944 4.74463 9.46019 4.74463 9.54167V10.4583C4.74463 10.5398 4.78537 10.5806 4.86685 10.5806H9.41963V15.3778C9.41963 15.4593 9.46037 15.5 9.54185 15.5H10.4585C10.54 15.5 10.5807 15.4593 10.5807 15.3778V10.5806H15.1335C15.215 10.5806 15.2557 10.5398 15.2557 10.4583V9.54167C15.2557 9.46019 15.215 9.41944 15.1335 9.41944H10.5807V4.62222C10.5807 4.54074 10.54 4.5 10.4585 4.5Z" fill="white"/>
                    <rect x="0.5" y="0.5" width="19" height="19" rx="2.5" stroke="white"/>
                </svg>
                </router-link>
            </div>


        </div>
    <div class="row col-md-12" id="support_tabs" style="margin: -3px 0 0 0;  border-bottom: 1px solid #93a8d6;">
        <div class="form-group mb-0 ml-1" id="tab_list">
            <ul class="nav nav-pills" role="tablist" id="tabs" style="font-size: 14px; font-weight: 500">
            <li class="nav-item type1 mr-4">
                <a class=" nav-link demo px-4" v-bind:class="[selectTab == 'all' ? 'active' : '']" href="javascript:void(0);" v-on:click="selectedStatus('all')" @click="supportStatus('all')" >All</a>
            </li>
            <li class="nav-item type1 mr-4">
                <a class="nav-link demo" v-bind:class="[selectTab == '0' ? 'active' : '']" href="javascript:void(0);" v-on:click="selectedStatus('0')" @click="supportStatus('0')">Open</a>
            </li>
            <li class="nav-item type2 mr-4">
                <a class="nav-link demo" v-bind:class="[selectTab == '1' ? 'active' : '']" href="javascript:void(0);" v-on:click="selectedStatus('1')" @click="supportStatus('1')">In Progress</a>
            </li>
            <li class="nav-item type2 mr-4">
                <a class="nav-link demo" v-bind:class="[selectTab == '3' ? 'active' : '']" href="javascript:void(0);" v-on:click="selectedStatus('3')" @click="supportStatus('3')">In Development</a>
            </li>
            <li class="nav-item type3 mr-4">
                <a class="nav-link demo" v-bind:class="[selectTab == '10' ? 'active' : '']" href="javascript:void(0);" v-on:click="selectedStatus('10')" @click="supportStatus('10')">Closed</a>
            </li>

            </ul>
        </div>
        <div class="float-right ml-auto" style="margin-top: 6px" id="support_filter">
        <div class="float-left mr-3">
          <div class="has-search" v-if="$can('all_tickets_search')">
            <span class="fa fa-search form-control-feedback"></span>
            <input v-model="search" @keyup="supportTicketSearch" type="text" style="background-color: #edf2f5"
              class="form-control" placeholder="Search Here..." />
          </div>
        </div>
        <!-- Filter Button-->
        <button class="btn btn-sm filter_collapsible_btn" style="border: 1px solid #48a6a6" type="button" data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample"  v-on:click="showFilter"  v-if="$can('all_tickets_filter')">
          <!-- <i class="fa fa-filter fa-lg py-1 icon bg-default"></i> -->
          <!-- <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
            <path
              d="M14.7358 0.484375H1.26203C1.03869 0.484375 0.824497 0.573097 0.666571 0.731024C0.508644 0.88895 0.419922 1.10314 0.419922 1.32649V3.50756C0.419922 3.94798 0.599292 4.38083 0.910873 4.69241L5.47259 9.25413V15.6424C5.47276 15.7859 5.50954 15.9269 5.57946 16.0522C5.64937 16.1775 5.75011 16.2829 5.87213 16.3583C5.99414 16.4338 6.13341 16.4769 6.27673 16.4835C6.42005 16.4901 6.56268 16.46 6.69113 16.3961L10.0596 14.7119C10.3451 14.5687 10.5253 14.2773 10.5253 13.9582V9.25413L15.087 4.69241C15.3986 4.38083 15.5779 3.94798 15.5779 3.50756V1.32649C15.5779 1.10314 15.4892 0.88895 15.3313 0.731024C15.1734 0.573097 14.9592 0.484375 14.7358 0.484375ZM9.08778 8.31012C9.00943 8.38819 8.94729 8.48098 8.90494 8.58316C8.8626 8.68534 8.84088 8.79489 8.84104 8.90549V13.4377L7.15682 14.2799V8.90549C7.15698 8.79489 7.13526 8.68534 7.09291 8.58316C7.05057 8.48098 6.98843 8.38819 6.91008 8.31012L2.10415 3.50756V2.1686H13.8946L13.8962 3.50166L9.08778 8.31012Z"
              fill="#48a6a6" />
          </svg> -->
          <i class="fa fa-filter" style="font-size:19px;color:#48a6a6;"></i>
        </button>
        <router-link  v-if="$can('all_tickets_create') && $route.fullPath == '/support'" to="/support/generate" class="btn float-right ml-2 add-ticket" id="add_new_default" style="  padding: 5px 8px 2px 8px;"> <span  style="font-size:20px;color:#48a6a6"  class="fa fa-plus"></span></router-link>
        <!-- End -->

        <!-- <button class="btn btn-sm" style="border: 1px solid #48a6a6" type="button" data-toggle="collapse"
          data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample"  v-on:click="ShowFilter">

          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
            <path
              d="M14.7358 0.484375H1.26203C1.03869 0.484375 0.824497 0.573097 0.666571 0.731024C0.508644 0.88895 0.419922 1.10314 0.419922 1.32649V3.50756C0.419922 3.94798 0.599292 4.38083 0.910873 4.69241L5.47259 9.25413V15.6424C5.47276 15.7859 5.50954 15.9269 5.57946 16.0522C5.64937 16.1775 5.75011 16.2829 5.87213 16.3583C5.99414 16.4338 6.13341 16.4769 6.27673 16.4835C6.42005 16.4901 6.56268 16.46 6.69113 16.3961L10.0596 14.7119C10.3451 14.5687 10.5253 14.2773 10.5253 13.9582V9.25413L15.087 4.69241C15.3986 4.38083 15.5779 3.94798 15.5779 3.50756V1.32649C15.5779 1.10314 15.4892 0.88895 15.3313 0.731024C15.1734 0.573097 14.9592 0.484375 14.7358 0.484375ZM9.08778 8.31012C9.00943 8.38819 8.94729 8.48098 8.90494 8.58316C8.8626 8.68534 8.84088 8.79489 8.84104 8.90549V13.4377L7.15682 14.2799V8.90549C7.15698 8.79489 7.13526 8.68534 7.09291 8.58316C7.05057 8.48098 6.98843 8.38819 6.91008 8.31012L2.10415 3.50756V2.1686H13.8946L13.8962 3.50166L9.08778 8.31012Z"
              fill="#48a6a6" />
          </svg>
        </button> -->

        </div>
    </div>
    <div :class="show_filter" class="row collapse mx-0 mt-0 filter-button" id="collapseExample">
        <div class="col-sm-12 col-md-3" >
            <div class="form-group">
              <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Select Organization</label>
              <multiselect @input="searchedOrganization" :options="organizations" :selectedLabel="null" :deselectLabel="null" :allow-empty="false" :selectLabel="null" :searchable="true" v-model="organization_search"
                label="name" track-by="organization_id" style="font-size:12px !important">
              </multiselect>
            </div>
        </div>
        <div class="col-sm-12 col-md-3">
            <!-- <div class="form-group"> -->
              <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Select Category</label>
              <multiselect class="category" @input="selectCategory" :options="category" :selectedLabel="null" :deselectLabel="null" :allow-empty="false" :selectLabel="null" :searchable="false" v-model="selected_category"
                label="name" track-by="value" style="font-size:12px !important">

              </multiselect>
            <!-- </div> -->
            <!-- <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Select Category</label>
            <select v-on:change="selectCategory($event)"  v-model="selected_category" class="form-control multiselect selectCategory" style="padding: 0px 8px;" placeholder="Select category">
                <option class="dropdown-item" style="width: 190px; height: 30px" value="all">
                    All
                </option>
                <option class="dropdown-item" style="width: 190px; height: 30px" value="0">
                    General Question
                </option>
                <option class="dropdown-item" style="width: 190px; height: 30px" value="1">
                    Customization or New Feature Request
                </option>
                <option class="dropdown-item" style="width: 190px; height: 30px" value="2">
                    Bug/System Error Report
                </option>
                <option class="dropdown-item" style="width: 190px; height: 30px" value="3">
                    System Improvement Suggestion
                </option>
                <option class="dropdown-item" style="width: 190px; height: 30px" value="4">
                    Request a call back
                </option>
                <option class="dropdown-item" style="width: 190px; height: 30px" value="5">
                    Request a zoom meeting
                </option>
            </select> -->
        </div>

        <div class="col-sm-12 col-md-6 " style=" display: flex; justify-content: right;  padding: 22px 17px 0px 0px;">
            <button type="button" class="btn btn-basic right mt-3 bg-green-default reset-button" style="margin: 0% 0% 5% 0%;">
                <span class="reset" @click="resetFilter"> Reset</span>
            </button>
        </div>
    </div>
    <div :class="show_filter" class="row collapse mx-0 mt-0 filter-button " id="collapsedExample" style="bottom:0; position:fixed;z-index: 1;">
        <div class="filter-hr" >
            <hr class="filter-line">
        </div>
       <div class="float-left mr-3 search-input">
          <div class="has-search">
            <span class="fa fa-search form-control-feedback"></span>
            <input v-model="search" @keyup="supportTicketSearch" type="text" style="background-color: #edf2f5"
              class="form-control" placeholder="Search Here..." />
          </div>
        </div>
        <div class="col-sm-12 col-md-3 search-organization" >
            <div class="form-group">
              <!-- <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Select Organization</label> -->
                <multiselect @input="searchedOrganization" :options="organizations" :selectedLabel="null" :deselectLabel="null" :allow-empty="false" :selectLabel="null" :searchable="true" v-model="organization_search"
                label="name" track-by="organization_id" style="font-size:12px !important">
              </multiselect>
            </div>
        </div>
        <div class="col-sm-12 col-md-3 category-group">
            <!-- <div class="form-group"> -->
              <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Category</label>
              <multiselect @input="selectCategory" :selectLabel="null" :selectedLabel="null" :deselectLabel="null" :options="category"  :allow-empty="false" :searchable="false" v-model="selected_category"
                label="name" track-by="value" style="font-size:12px !important" >
              </multiselect>
            <!-- </div> -->
        </div>

        <button type="button" class="btn btn-primary" style="width: 100%; background-color: #48a6a6 !important; margin-top:3%;" @click="closeFilter">Close</button>
         <!-- <div class="col-sm-12 col-md-6 " style=" display: flex; justify-content: right;  padding: 22px 17px 0px 0px;">
            <button type="button" class="btn btn-basic right mt-3" style="background-color: rgb(38, 107, 162); margin: 0% 0% 5% 0%;">
                <span style="color:white" @click="reset=true; searchedOrganization() ;"> Reset</span>
            </button>
         </div> -->
    </div>
</div>
</template>
<script>
import axios from "axios";
import Multiselect from "vue-multiselect";
import $ from 'jquery';
import VueSkeletonLoader from 'skeleton-loader-vue';
export default {
  name: 'ticket_filter',
  components: {
    Multiselect, VueSkeletonLoader
  },

  props: [ "tickets","page","filtersBtn"],
  data() {
    return{
      selectTab: 'all',
      search: "",
      board_lists: [],
      // category:  [
      //     "General Question",
      //     "Customization or New Feature Request",
      //     "Bug/System Error Report",
      //     "System Improvement Suggestion",
      //     "Request a call back",
      //     "Request a zoom meeting",
      // ],
      show_filter: false,
      selected_category: "",
      organization_search: "",
      organizations: [],
      category: [
        {name:"All", value:"all"},
        {name:"General Question", value:"0"},
        {name:"Customization or New Feature Request", value:"1"},
        {name:"Bug/System Error Report", value:"2"},
        {name:"System Improvement Suggestion", value:"3"},
        {name:"Request a call back", value:"4"},
        {name:"Request a zoom meeting", value:"5"}
      ],
      reset: false,
      skeletonLoader: false,
      pageNumber: null
    }
  },
  mounted: function(){
    $('.filter_collapsible_btn').trigger("click");
  },
  created: function(){
    this.organizationSearch();
    this.selected_category = this.category[0];
    if (localStorage.getItem("supportTab") != null) {
      this.selectTab = localStorage.getItem("supportTab");
      this.$emit("setSupportStatus",  this.selectTab);
    } else {
      this.selectTab = 'all';
    }
  },


  methods:{

    filterCheck(){
      this.organization_search = this.organizations[0];
      this.search = '';
      this.selected_category= "";
      if(!this.show_filter){
        this.show_filter = 'show';
        if($( window ).width() > 319 && $( window ).width()< 681){
          $(".table-responsive").css("background","rgb(191 191 191)");
          $(".table-responsive").css("pointer-events","none");
        }
        localStorage.setItem('show_filter', 'show');
      }else{
        this.show_filter = false;
        if($( window ).width() > 319 && $( window ).width()< 681){
          $(".table-responsive").css("pointer-events","auto");
          $(".table-responsive").css("background","white");
        }
        localStorage.setItem('show_filter',false);
      }

    },
    backButton(){
      this.$router.go(-1);
    },
    selectedStatus(event) {
      this.organization_search = this.organizations[0];
      this.selected_category = this.category[0]
      this.$emit("setFilters", this.organization_search.name,this.selected_category.value);
      this.$emit("selectSupportTab", event);
    },
    supportStatus(status){
      this.page =1;
      this.show_filter = false;
      this.organization_search = this.organizations[0];
      this.selected_category = this.category[0];
      localStorage.setItem('show_filter', false)
      if($( window ).width() > 319 && $( window ).width()< 681){
        $(".table-responsive").css("pointer-events","auto");
        $(".table-responsive").css("background","white");
      }

      this.$emit("setSupportStatus", status);
      this.selectTab = status;
      localStorage.setItem("supportTab",status)
      // let loader = this.$loading.show({
      //     loader: "dots",
      //     container: this.fullPage ? null : this.$refs.formContainer,
      // });
      this.skeletonLoader = true;
      this.$emit("skeletonLoader", this.skeletonLoader);
      this.$emit("setFilters",this.search, this.organization_search.name,this.selected_category.value);
      // this.setPage(this.page);
      // this.organization_search = this.organization_search.name;
      // this.search = '';
      // this.selected_category= this.selected_category.value;

      this.$store.dispatch("support/getAllTickets", [1, status,this.search,true,this.organization_search.name,this.selected_category.value])
          .then(()=>{
            this.$emit("setPage", 1);
            setTimeout(() => {

              this.skeletonLoader = false;
              this.$emit("skeletonLoader", this.skeletonLoader);
            },1000);

          });


    },
    setPage(page) {
      this.filtersBtn;
      this.pageNumber = page;
      this.$emit("setFilters", this.search,this.organization_search.name,this.selected_category.value);
      this.$emit("setPage", page);
    },
    supportTicketSearch(){
      this.selected_category= this.category[0];
      this.organization_search = this.organizations[0];
      let loader;
      this.setPage(1);
      if(this.search.length > 2 || this.search.length == 0) {
        this.skeletonLoader = true;
        this.$emit("skeletonLoader", this.skeletonLoader);
        this.$emit("setFilters", this.search,this.organization_search.name,this.selected_category.value);
        this.$store.dispatch("support/getAllTickets", [1,  this.selectTab,this.search,true,this.organization_search.name,this.selected_category.value])
            .then(()=>{
              setTimeout(() => {
                this.skeletonLoader = false;
                this.$emit("skeletonLoader", this.skeletonLoader);
              },1000);
            });

        // loader.hide();

      }
      // setTimeout(() => {

      //   this.skeletonLoader = true;
      // this.$emit("skeletonLoader", this.skeletonLoader);
      // }, 2000);
    },
    showFilter(){
      this.show_filter == 'show' ?  localStorage.setItem('show_filter', false) :  localStorage.setItem('show_filter', 'show');
    },
    selectCategory(category){
      // this.organization_search = this.organizations[0];
      // this.search = '';
      if(category.value == "all"){
        category.value = '';
      }
      let category_value = true;
      // this.show_filter = false;
      // localStorage.setItem('show_filter', false);
      // if($( window ).width() > 319 && $( window ).width()< 681){
      //         $(".table-responsive").css("pointer-events","auto");
      //         $(".table-responsive").css("background","white");
      //     }


      this.skeletonLoader = true;
      this.$emit("skeletonLoader", this.skeletonLoader);
      this.$emit("setFilters", this.search,this.organization_search.name,category.value);
      this.$store.dispatch("support/getAllTickets", [1,  this.selectTab,this.search,category_value,this.organization_search.name,category.value])
          .then(()=>{
            // setTimeout(() => {
              this.skeletonLoader = false;
              this.$emit("skeletonLoader", this.skeletonLoader);
            // },2000);
          });

    },
    async organizationSearch() {
      // let loader = this.$loading.show({
      // loader: "dots",
      // });
      this.skeletonLoader = true;
      this.$emit("skeletonLoader", this.skeletonLoader);
      const permission = {
        headers: {
          'X-Permission': 'all_organization_list'
        }
      };
      await axios
          .get("/admin/users/get-all-organizations",permission)
          .then((response) => {
            this.organizations = response.data;
            this.organizations.unshift({
              name: "All",
              organization_id: "",
            });
            this.organization_search = this.organizations[0];
            // loader.hide();
            setTimeout(() => {
              this.skeletonLoader = false;
              this.$emit("skeletonLoader", this.skeletonLoader);
            },1000);
          })
          .catch((error) => {
            // loader.hide();
            this.skeletonLoader = false;
            this.$emit("skeletonLoader", this.skeletonLoader);
          });
    },
    searchedOrganization(){
      // this.search = '';
      // this.selected_category= this.category[0];
      let orgName;

      if(this.reset == true ){
        orgName = '' ;
        this.organization_search = this.organizations[0];
      }else{
        orgName =  this.organization_search.name;
      }
      orgName == "All" ? orgName = '':"";
      this.skeletonLoader = true;
      this.$emit("skeletonLoader", this.skeletonLoader);
      this.$emit("setFilters", this.search,orgName,this.selected_category.value);
      this.setPage(1);
      this.$store.dispatch("support/getAllTickets", [1,  this.selectTab,'',true,orgName,this.selected_category.value])
          .then(()=>{
            // setTimeout(() => {
              // loader.hide();
              //
              this.skeletonLoader = false;
              this.$emit("skeletonLoader", this.skeletonLoader);
              this.reset = false ;
            // }, 2000);
          });
    },
    resetFilter(){
      if(this.search != '' || this.selected_category.name != "All" || this.organization_search.name != "All")
      {
        this.search = '';
        this.selected_category= this.category[0];
        this.organization_search = this.organizations[0];
        this.reset == true
        this.skeletonLoader = true;
        this.$emit("skeletonLoader", this.skeletonLoader);
        this.$emit("setFilters", '','','');
        this.setPage(1);
        this.$store.dispatch("support/getAllTickets", [1,  this.selectTab,'',false])
            .then(()=>{
              setTimeout(() => {
                this.skeletonLoader = false;
                this.$emit("skeletonLoader", this.skeletonLoader);
                this.reset = false ;
              }, 1000);
            });
      }

    },
    closeFilter(){
      this.show_filter = false;
      localStorage.setItem('show_filter', false);
      if($( window ).width() > 319 && $( window ).width()< 681){
        $(".table-responsive").css("pointer-events","auto");
        $(".table-responsive").css("background","white");
      }
    }

  }
}


</script>
<style scoped lang="scss">
.btn:hover {
      background:  rgb(72, 166, 166) !important;
      .fa-filter, .fa-plus{
        color:white !important;
    }
  }
  .add-ticket{
    border: 1px solid  rgb(72, 166, 166) !important;
  }
//   .btn:hover.fa-filter, .fa-plus{
//     color:white !important;
//   }
    .reset-button:hover{
        background: white !important;
        border:1px solid rgb(72, 166, 166) !important;
        >.reset{
            color: rgb(72, 166, 166) !important;
        }
    
  }
  .reset-button {
    padding: 0.1rem 0.5rem 0.2rem !important;
  }
</style>

<style>
    .has-search .form-control{
        height: calc(1.2em + 0.75rem + 2px);
    }
    select[class="form-control "]{
        height: calc(1.8em + 0.75rem + 2px) !important;
    }
    .dropdown-item {
        cursor: pointer;
    }

    #tabs .nav-link {
        background: transparent;
        color: rgb(66, 64, 64);
    }

    #tabs .active {
        background-color: #48a6a6 !important;
        color: white;
    }
  .filter-button{
    background-color: #f7f8f9;
    border-bottom: 1px solid #93a8d6;
    margin-bottom: 0;
    }
    #filter_responsive, #add_new_responsive ,#ticket_responsive{
        display: none !important;
    }
    .category{
        border-radius: 0rem !important;
    }
    .multiselect__placeholder {
        margin-bottom: 7px !important;
        padding-top: 0px !important;
    }
    .multiselect .multiselect__tags {
        min-height: 40px !important;
    }
    @media (min-width: 375px) and (max-width:680px){
        #tab_list{
            width: 100% !important;
            padding: 0% 3% !important;

        }
        #tabs{
            justify-content: space-between !important;
        }
        li.type1  a{
            padding-left: 1.5rem !important;
            padding-right: 1.5rem !important;
        }
        li.type2  a{
            padding-left: 1rem !important;
            padding-right: 1rem !important;
        }
        li.type3  a{
            padding-left: 1rem !important;
            padding-right: 1rem !important;
        }
        /* #table_body{
            padding:  0% 3% !important;
        } */
    }
   
    @media (min-width: 320px) and (max-width:680px){
        .form-control{
            font-size: 0.85rem !important;
        }
        #support_filter,#collapseExample{
            display:none !important;
        }
        #support_tabs{
            display: flex;
            align-items: center;
            justify-content: center;
            /* margin: 0px 2% !important; */
            padding: 3% 0% !important; 
            border-bottom: 0px !important;
            background-color: white !important;
        }
        #support_tabs ul{
            font-size: 12px !important;           
        }
         #support_tabs ul >li >a{
            border: 1px solid rgb(222 225 230);
         }
        
        #support_tabs ul li:not(:last-child){
            margin-right: 0.2rem !important;
            /* border: 1px solid rgb(222 225 230); */
            border-radius: 5px;
        }
        #support_tabs ul li:last-child{
            margin-right: 0rem !important;
            /* border: 1px solid rgb(222 225 230); */
            border-radius: 5px;    
        }
        #tab_list{
            margin-left: 0.1rem !important;
            
        }
        #support_subheading,#add_new_default,#ticket_default{
            display: none !important;
        }
        #filter_responsive, #add_new_responsive, #ticket_responsive{
            display: block !important;
        }
        #support_heading{
            padding-left: 32% !important;
        }
        #support_heading p{
            margin-bottom: 0.6rem !important;
        }
        #back_button{
            display: block !important;
        }
        #ticket_responsive{
            margin: 0% -5% ;
        }
        #add_new_responsive{
            margin-right: 2% ;
        }
        .category-group{
            padding:0px;
        }
        .category-group>label{
            position: absolute;
            z-index: 1;
            top: -12px;
            left: 20px;
            background-color: white;
        }

        .category-group>input{
            border:none;
        }
        .multiselect__tags{
            padding: 8px 40px 0 8px  !important;
            font-size: 11px !important;

        }
        select[class="form-control "] {
            height: calc(1.8em + 0.5rem + 0px) !important;
        }
        .search-organization{
            padding: 10px 0px 10px 0px !important;
        }
        .multiselect{
            min-height: 13px !important;
        }
        #collapsedExample{
            background-color: white;
            padding: 21px !important;
            border-top-left-radius: 9%;
            border-top-right-radius: 9%;

        }
        .search-input,.has-search{
            width: 106% !important;
        }
        .search-input{
            padding-bottom: 12px !important;
        }
        .search-input input{
            background-color: white !important;
        }
        hr.filter-line{
            border: 3px solid #dee1e6;
            width: 50% !important;
        }
        .filter-hr{
            display: flex;
            align-items: center;
            justify-content: center;
            padding-top: 0px;
            margin-top: -9%;
            margin-bottom: 12px;
            width: 100% !important;
 
        }
        .multiselect .multiselect__tags {
            min-height: 40px !important;
        }
    }
</style>